import { Grid } from '@mui/material';
import { useContext, useLayoutEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';

import { EMPLOYEE } from '../../constants/roles';
import Error404 from '../../pages/Error/Error404';
import Navbar from '../NavBar';
import ProjectWarningContext from '../../context/ProjectWarningContext';
import useLoader from '../../context/LoaderContext';
import useProjectVersionHistory from '../../context/VersionHistoryContext';
import useWorkspace from '../../context/WorkspaceContext';

const WorkspaceTemplate = ({ children }) => {
  // init
  const { showRiskBar } = useContext(ProjectWarningContext);
  const { showVersionHistoryBar } = useProjectVersionHistory();

  // constants
  const original = { width: 'calc(100% - 80px)' };
  const withRiskBar = { width: 'calc(100% - 80px - 300px)' };
  const withVersionHistoryBar = { width: 'calc(100% - 80px - 434px)' };
  let gridItemStyle = original;

  if (showVersionHistoryBar) {
    gridItemStyle = withVersionHistoryBar;
  } else if (showRiskBar) {
    gridItemStyle = withRiskBar;
  }

  return (
    <Grid container direction="row">
      <Grid item style={{ width: '80px' }}><Navbar /></Grid>
      <Grid item className="main-grid-item" style={gridItemStyle}>{children}</Grid>
    </Grid>
  );
};

const WorkspaceLayout = ({ children, isAllowed }) => {
  // init
  const { setIsLoading } = useLoader();
  const { pathname } = useLocation();
  const { workspace, userPermissions } = useWorkspace();

  // constants
  const isAllowedToAccess = useMemo(() => (userPermissions
    ? Object.values(isAllowed).includes(userPermissions.roleId)
    : Object.values(isAllowed).includes(EMPLOYEE)), [userPermissions, pathname]);

  useLayoutEffect(() => {
    if (userPermissions && !isAllowedToAccess) setIsLoading(false);
    if (workspace && workspace?.logo) document.getElementById('favicon')?.setAttribute('href', workspace.logo);
    else document.getElementById('favicon')?.setAttribute('href', '/favicon.ico');
  }, [userPermissions]);

  if (userPermissions && !isAllowedToAccess) {
    return <WorkspaceTemplate><Error404 /></WorkspaceTemplate>;
  }

  return <WorkspaceTemplate>{isAllowedToAccess ? children : null}</WorkspaceTemplate>;
};

const propTypes = {
  children: PropTypes.node.isRequired,
  isAllowed: PropTypes.arrayOf(PropTypes.number).isRequired,
};

WorkspaceTemplate.propTypes = {
  children: PropTypes.node,
};

WorkspaceLayout.propTypes = propTypes;

export default WorkspaceLayout;
